<template>
  <div class="signup">
     <form class="input-container" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input id="checkout-cadastro-e-mail" v-model="email" :placeholder="$t('auth.signUp.placeholder.email')" type="email" :error="$v.email.$error" />
      <pk-input id="checkout-cadastro-senha" v-model="password" :placeholder="$t('auth.signUp.placeholder.password')" type="password" :error="$v.password.$error" />

      <error-text :active="!!errorCode || !!$v.$error">
        <span v-if="errorCode === 409">
          <span v-html="$t('auth.signUp.error.emailAlreadyExists.message')" />
          <a @click.prevent="goToLogin">{{ $t('auth.signUp.error.emailAlreadyExists.CTA') }}</a>
        </span>
        <span v-else-if="errorCode === 400" v-t.preserve="'auth.signUp.error.invalidRequest'" />
        <span v-else-if="!!errorCode" v-t.preserve="'auth.signUp.error.generic'" />
        <span v-else-if="$v.email.$error" v-t.preserve="emailError" />
        <span v-else-if="$v.password.$error" v-t.preserve="'auth.signUp.error.password'" />
      </error-text>

      <consent-box v-model="consentPolicy" :shake="shakeBoxPrivacy" id="checkout-cadastro-cta-politica-de-privacidade">
        {{ $t('policies.privacy') }} <a id="checkout-cadastro-opt-in-politica-de-privacy" :href="`${$t('policies.privacyLink')}/${this.consentVersion}`" target="_blank">{{ $t('policies.privacyTitle') }}</a>
      </consent-box>

      <consent-box v-model="consentTerms" :shake="shakeBoxTerms" id="checkout-cadastro-cta-termos-de-uso">
        {{ $t('policies.tos') }} <a id="checkout-cadastro-opt-in-termos-de-serviço" :href="`${$t('policies.tosLink')}/${this.consentVersion}`" target="_blank">{{ $t('policies.tosTitle') }}</a>
      </consent-box>

      <btn flat :loading="loading" submit id="checkout-cadastro-cta-1-cadastrar">{{ $t('auth.signUp.signUp') }}</btn>

      <span>
        {{ $t('auth.signUp.signIn.message') }}
        <a @click.prevent="goToLogin" id="checkout-cadastro-cta-clique-aqui-para-entrar">
          {{ $t('auth.signUp.signIn.CTA') }}
        </a>
      </span>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { AuthenticationPlatform } from '@/api/peanutbutter'
import authenticationService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'
import { ifoodEmail, strongPassword } from '@/js/validationUtils'
import { latestConsentVersion, ConsentVersionAppMap } from '@/js/consentVersionMap'

export default {
  name: 'sign-up-email',
  mixins: [formSubmit('signup')],
  data: () => ({
    email: '',
    password: '',
    consentVersion: latestConsentVersion,
    consentPolicy: false,
    consentTerms: false,
    shakeBoxPrivacy: false,
    shakeBoxTerms: false
  }),

  computed: {
    isIfoodOffer() {
      return this.$route.params.offer === 'ifood'
    },

    emailError() {
      return this.isIfoodOffer
        ? 'auth.signUp.error.ifoodEmail'
        : 'auth.signUp.error.email'
    }
  },

  validations() {
    const validations = {
      email: { required, email },
      password: { required, strongPassword }
    }

    if (this.isIfoodOffer) {
      validations.email = { required, ifoodEmail }
    }

    return validations
  },

  watch: {
    '$v.$invalid' (next) {
      this.$emit('email-form', next)
    }
  },

  methods: {
    goToLogin () {
      this.$router.push({ name: 'login', params: { ...this.$route.params }, query: { ...this.$route.query } })
    },
    verifyPolicyConsent() {
      this.shakeBoxPrivacy = false
      this.shakeBoxTerms = false

      if (!this.consentPolicy) {
        this.$nextTick(() => {
          this.shakeBoxPrivacy = true
        })
      }

      if (!this.consentTerms) {
        this.$nextTick(() => {
          this.shakeBoxTerms = true
        })
      }

      if (!this.consentPolicy || !this.consentTerms) {
        return false
      }

      return true
    },

    async signup() {
      if (!this.verifyPolicyConsent()) {
        return
      }

      const data = {
        credentials: {
          email: this.email,
          password: this.password
        },
        extraData: {},
        authenticationPlatform: AuthenticationPlatform.EMAIL,
        privacyPreferences: {
          privacyPolicy: {
            consent: this.consentPolicy,
            version: ConsentVersionAppMap[this.consentVersion]
          },
          termsOfUse: {
            consent: this.consentTerms,
            version: ConsentVersionAppMap[this.consentVersion]
          }
        }
      }

      try {
        await authenticationService.signUp(data)

        this.$emit('authenticated')
      } catch (err) {
        if (err.code) {
          throw err
        }

        this.errorCode = 400
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signup {
  .input-container {
    & > .consent-box {
      margin-bottom: 12px;
    }
    .pk-input {
      margin: 1rem 0
    }

    & > span {
      text-align: center;
      margin-bottom: 8px;
      font-weight: normal;

      &:last-child {
        margin-top: 8px;
      }
    }

    .signup-types {
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (min-width: 1200px) {
    .input-container {
      & > .btn {
        margin-bottom: 16px;
      }

      & > span {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
